import React, { useState, useEffect } from "react";
import { Button, Spinner, Alert, Card, CardBody } from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAllPermissions,
  getMantisBusiness,
  updateBusinessPermissions,
} from "../../ApiCalls/backoffice";

const select = (state) => ({
  userId: state.auth.userId,
  token: state.auth.token,
});

function BusinessPermissionsTab(props) {
  const [mantisBusiness, setMantisBusiness] = useState(null);
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [permissionOptions, setPermissionOptions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [updating, setUpdating] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const { id } = useParams();

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (permissions.length > 0 && mantisBusiness?.enabledPermissions) {
      let selected = [];
      setPermissionOptions(
        permissions.map((permission) => ({
          value: permission,
          label: permission.friendlyName,
        }))
      );
      permissions.forEach((permission) => {
        if (
          mantisBusiness.enabledPermissions
            .map((p) => p.permission)
            .includes(permission.permission)
        ) {
          selected.push({
            value: permission,
            label: permission.friendlyName,
          });
        }
      });
      setSelectedPermissions(selected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions, mantisBusiness]);

  async function loadData() {
    const businessRes = await getMantisBusiness(props.token, props.userId, id);
    if (businessRes.success) {
      setMantisBusiness(businessRes.mantisBusiness);
    }

    const permissionsRes = await getAllPermissions(props.userId, props.token);
    if (permissionsRes.success) {
      setPermissions(permissionsRes.permissions);
    }
    setLoading(false);
  }

  async function handleUpdatePermissions() {
    setUpdating(true);
    const permList = selectedPermissions.map((p) => p.value);
    const res = await updateBusinessPermissions(
      props.userId,
      id,
      permList,
      props.token
    );
    if (res.success) {
      setAlertMessage("Permisos actualizados correctamente");
    } else {
      setAlertMessage("Error al actualizar los permisos");
    }
    setUpdating(false);
  }

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <div>
      {alertMessage && (
        <Alert
          color={alertMessage.includes("Error") ? "danger" : "info"}
          isOpen={alertMessage !== ""}
          toggle={() => setAlertMessage("")}
          className="mb-3"
        >
          {alertMessage}
        </Alert>
      )}

      <Card>
        <CardBody>
          <h3 className="card-title mb-4">
            <i className="fas fa-shield-alt"></i> Permisos habilitados
          </h3>
          <div className="permissions-content">
            <Select
              options={permissionOptions}
              closeMenuOnSelect={false}
              isMulti
              value={selectedPermissions}
              onChange={setSelectedPermissions}
              className="custom-select"
              placeholder="Selecciona los permisos..."
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPortalTarget={document.body}
            />
            <Button
              onClick={handleUpdatePermissions}
              disabled={updating}
              className="update-button mt-3"
              color="primary"
            >
              {updating ? (
                <span className="button-content">
                  <Spinner size="sm" />
                  Actualizando...
                </span>
              ) : (
                <span className="button-content">
                  <i className="fas fa-save"></i> Actualizar permisos
                </span>
              )}
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default connect(select)(BusinessPermissionsTab);
